/* eslint-disable no-async-promise-executor */
import socketService, { SocketService } from './socketService';
import env from 'env';
import { safeParse, safeStringify, sentryError } from '../../utils';
import api from '../../api';
import { FIVE_SECONDS } from 'data/global';

let reconnectTimeout: NodeJS.Timeout;
let reconnectTime = FIVE_SECONDS;

function connect(this: SocketService) {
  return new Promise(async (resolve, reject) => {
    this.isClosed = false;

    clearTimeout(reconnectTimeout);

    const {
      data: { token },
    } = await api.websocket.getToken();

    this.socket = new WebSocket(`${env.WS_SERVER_ENDPOINT}?at=${token}`);

    this.socket.addEventListener('message', (ev) => {
      const event = safeParse(ev.data);

      const { eventType, eventData } = event;

      if (!eventType) {
        sentryError(
          new Error(
            `Received socket event without type: ${safeStringify(event)}`,
          ),
        );

        return;
      }

      this.consumers[eventType]?.forEach((cb) => cb(eventData));
    });

    this.socket.addEventListener('close', (ev) => {
      if (this.isClosed) return;

      if (!this.shouldReconnect) {
        (ev as any).errorType = 'Websocket close error';
        sentryError(ev);
        return reject(ev.reason);
      }

      if (ev.wasClean) {
        this.connect();
      } else {
        // If not clean wait for reconnectTime

        reconnectTimeout = setTimeout(() => {
          reconnectTime += FIVE_SECONDS;
          if (this.isClosed) return;

          // connect only if it wasn't closed in the meantime
          this.connect();
        }, reconnectTime);
      }
    });

    this.socket.addEventListener('open', () => {
      resolve('');
    });
  });
}

export default socketService(connect);
